module.exports = __webpack_public_path__ + "static/img/industriesbg4.3497cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg4.jpg
// module id = LdeY
// module chunks = 1